import { c as _c } from "react/compiler-runtime";
import { useToast } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
export type KeyEnvironment = 'sandbox' | 'production';

// A playbook's key suffix is the same in both environments — only the prefix differs (see
// PlaybookKeySuffix::key_for_environment). Swapping the token inside whichever prefix the API
// returned keeps legacy `ob_` keys legacy, so the cutoff that decides that stays on the backend.
const ENVIRONMENT_PREFIX = /^(pb|ob)_(test|live)_/;
const publishableKeyFor = (versionKey: string, environment: KeyEnvironment): string | null => {
  if (!ENVIRONMENT_PREFIX.test(versionKey)) return null;
  const token = environment === 'sandbox' ? 'test' : 'live';
  return versionKey.replace(ENVIRONMENT_PREFIX, (_match, family) => `${family}_${token}_`);
};
export const useCopyPublishableKey = versionKey => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "publishableKey"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t0);
  const {
    toast
  } = useToast();
  let t1;
  if ($[1] !== t || $[2] !== toast || $[3] !== versionKey) {
    t1 = async environment => {
      const key = publishableKeyFor(versionKey, environment);
      if (!key) {
        return;
      }
      ;
      try {
        await navigator.clipboard.writeText(key);
        toast({
          title: t(_temp),
          description: t($_0 => $_0.feedback[environment])
        });
      } catch (t2) {
        const error = t2;
        console.error("Failed to copy publishable key:", error);
      }
    };
    $[1] = t;
    $[2] = toast;
    $[3] = versionKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const copy = t1;
  let t2;
  if ($[5] !== versionKey) {
    t2 = environment_0 => publishableKeyFor(versionKey, environment_0);
    $[5] = versionKey;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== copy || $[8] !== t2) {
    t3 = {
      copy,
      keyFor: t2
    };
    $[7] = copy;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
function _temp($) {
  return $.feedback.title;
}